import { render, staticRenderFns } from "./edit-table.vue?vue&type=template&id=6f407610&scoped=true"
import script from "./edit-table.vue?vue&type=script&lang=js"
export * from "./edit-table.vue?vue&type=script&lang=js"
import style0 from "./edit-table.vue?vue&type=style&index=0&id=6f407610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f407610",
  null
  
)

export default component.exports